import { CASHBACK_COMPANY_DB } from '../../config'

export const INVOICE_SRC_OBJ_TYPE = 13

export const CASHBACK_STATUS_META = {
	AVAILABLE: { label: 'Mavjud', className: 'bg-sky-100 text-sky-700' },
	ACTIVE: { label: 'Aktiv', className: 'bg-sky-100 text-sky-700' },
	USED: { label: 'Ishlatilgan', className: 'bg-emerald-100 text-emerald-700' },
	EXPIRED: { label: 'Muddati o‘tgan', className: 'bg-rose-100 text-rose-700' },
	CANCELLED: { label: 'Bekor qilingan', className: 'bg-slate-200 text-slate-600' },
}

export const CASHBACK_TYPE_META = {
	EARN: { label: 'Hisoblangan', className: 'bg-indigo-50 text-indigo-700' },
	REDEEM: { label: 'Yechilgan', className: 'bg-amber-50 text-amber-700' },
}

export const firstPhone = (raw) =>
	String(raw || '')
		.split(',')
		.map((value) => value.trim())
		.filter(Boolean)[0] || ''

export const belongsToSale = (entry, docEntry) =>
	Number(entry?.saleId) === Number(docEntry) &&
	(!entry?.companyDb || entry.companyDb === CASHBACK_COMPANY_DB)

export const entryJournalNumbers = (entry) =>
	[
		entry?.journalEntryNumber,
		...(entry?.postings || []).map((posting) => posting?.journalEntryNumber),
	]
		.filter(Boolean)
		.map(String)

export const findEntryReconciliation = ({
	entry,
	docEntry,
	reconciliations,
	reconciliationLines,
}) => {
	const journalNumbers = entryJournalNumbers(entry)
	if (!journalNumbers.length) return null

	for (const invoiceLine of reconciliations) {
		const reconNum = invoiceLine?.reconNum
		const counterpart = (reconciliationLines[reconNum] || []).find(
			(line) =>
				String(line?.sourceObjectEntry ?? '') !== String(docEntry) &&
				journalNumbers.includes(String(line?.transId ?? '')),
		)
		if (counterpart) return { invoiceLine, counterpart }
	}
	return null
}

export const sumAmount = (entries) =>
	entries.reduce((sum, entry) => sum + Number(entry?.amount || 0), 0)
